import { render, staticRenderFns } from "./UndoRedoControls.vue?vue&type=template&id=5f02883c&"
import script from "./UndoRedoControls.vue?vue&type=script&lang=js&"
export * from "./UndoRedoControls.vue?vue&type=script&lang=js&"
import style0 from "./UndoRedoControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UndoRedoControls.vue"
export default component.exports